// HWPUNIT = 1/7200 inch
const HWPUNIT_PER_INCH = 7200;
const MM_PER_INCH = 25.4;
const PT_PER_INCH = 72;

export function mmToHwpunit(mm: number): number {
  return Math.round((mm / MM_PER_INCH) * HWPUNIT_PER_INCH);
}

export function hwpunitToMm(hu: number): number {
  return (hu / HWPUNIT_PER_INCH) * MM_PER_INCH;
}

export function ptToHwpunit(pt: number): number {
  return Math.round((pt / PT_PER_INCH) * HWPUNIT_PER_INCH);
}

export function hwpunitToPt(hu: number): number {
  return (hu / HWPUNIT_PER_INCH) * PT_PER_INCH;
}

export function pxToHwpunit(px: number, dpi = 96): number {
  return Math.round((px / dpi) * HWPUNIT_PER_INCH);
}

export function hwpunitToPx(hu: number, dpi = 96): number {
  return (hu / HWPUNIT_PER_INCH) * dpi;
}

/** 한글 글자 크기 단위: 1pt = 100 unit */
export function ptToCharHeight(pt: number): number {
  return Math.round(pt * 100);
}

export function charHeightToPt(height: number): number {
  return height / 100;
}
